import jQuery from 'jquery';

;(function($){

//========================================================
//
// ■XJStorageLoaderクラス定義
//
//========================================================
$(function(){
	const $this = $('#irGovernance');
	if(!$this.length) return;

  $this.prepend('<ul class="c-irNewsList" data-id="xj-mainlist"></ul>');


  /*========================================================
    コンストラクタAS80522
  ========================================================*/
  var XjStorageLoaderLibraryKessan = function(s)
  {
    var defaults = {
      domain:'https://www.xj-storage.jp',
      company:    'AS80522',
      documents_koukoku:'32,33,109',
      display_id_koukoku:'xj-mainlist'
    };

    this.settings = $.extend(defaults, s);
    this.xjlist_koukoku = [];

    //this.fdate;
    //this.pdate;
    //this.documents;

    //initメソッド実行
    XjStorageLoaderLibraryKessan.prototype.init.call(this);
    };

  /*========================================================
    初期設定
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.init = function()
  {

    $.ajaxSetup({scriptCharset:'utf-8'});

    var self = this;

    var xjurl ;

    this.xjlist_koukoku.length = 0;
    xjurl = this.createUrl ( self.settings.documents_koukoku ) ;
    this.prepareList ( self.xjlist_koukoku, xjurl,
        self.settings.display_id_koukoku ) ;

    //this.show();
  };

  /*========================================================
    情報取得用URL生成
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.createUrl = function ( code )
  {
    var self = this;
    var xjurl;

    xjurl = self.settings.domain + '/public-list/GetList.aspx?company=';
    xjurl+= self.settings.company;

    if(self.settings.len && self.settings.len > 0){
      xjurl+= '&len=' + self.settings.len;
    }
    else {
      xjurl+= '&len=10000';
    }

    if (code && code.length > 0) {
      xjurl+= '&doctype=' + code;
    }

    xjurl+= '&filetype=PDF-GENERAL';
    xjurl+= '&output=json&callback=?';

    //clipboardData.setData('text',xjurl);

    return xjurl;
  }

  /*========================================================
    年度振り分け情報込みの情報格納
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.prepareList = function ( xjlist, xjurl,
      display_id )
  {
    var self = this;

    $.ajax({
      url: xjurl,
      dataType: 'json',

      success : function(data, dataType){

        if ( undefined == data.items )
        {
          return ;
        }

        $.each(data.items, function(i,item)
        {
          var onelist = {};

          // ファイル関連のプロパティ生成
          if (item.files)
          {
            $.each(item.files, function(j,file)
            {
              if ( file.type == 'PDF-GENERAL')
              {
                onelist.url = file.url;
                onelist.size = parseInt(file.size);
                onelist.page = file.page  ;
              }
            });
          }
          if ( !onelist.url )
          {
            onelist.url = '' ;
          }

          if ( !onelist.size )
          {
            onelist.size = 0 ;
          }

          if ( !onelist.page )
          {
            onelist.page = 0 ;
          }

          //ファイルサイズの生成
          if (onelist.size > 0) {
            if (onelist.size > 1000000) {
              onelist.size = parseInt(onelist.size/1000000) + 'M';
            } else if (onelist.size > 1000) {
              onelist.size = parseInt(onelist.size/1000) + 'K';
            }
          }
          else
          {
            onelist.size = '－';
          }

          //ページ数の生成
          if (onelist.page > 0)
          {
            onelist.page = onelist.page ;
          }
          else
          {
            onelist.page = '－';
          }

          //タイトル文
          onelist.title = item.title;

          // 日付関連
          onelist.date = item.publishDate.split(' ')[0].split('/');
          onelist.date_format = onelist.date[0] + '年' + onelist.date[1] + '月' + onelist.date[2] + '日' ;

          //XJ-Storageリストに格納
          xjlist.push(onelist);
        });
      },
      complete : function(XMLHttpRequest, textStatus){

        self.show(xjlist, display_id);
      }
    });
  }

  /*========================================================
    表示処理
  ========================================================*/
  XjStorageLoaderLibraryKessan.prototype.show = function(xjlist, display_id)
  {
    var self = this;
    var cont = '';
    var repeat_cont = '';


    /* メイン出力内容
    -----------------------------------------------*/
    $this.find( '[data-id="' + display_id + '"]').empty ( ) ;

    for ( var i = 0 ; i < xjlist.length ; i++ )
    {
      
      if ( 0 < i )
      {
        break ;
      }
      
      var xj_data = xjlist[ i ] ;

      //年度絞り込み
      /*if ( self.active_select !== xj_data.fiscalyear )
      {
        continue ;
      }*/
      
      repeat_cont += '<li>';

      //repeat_cont += '<th class="eventTableDate">' + xj_data.date_format + '</th>' ;

      repeat_cont += '<span class="clearfix">' ;
          
      if  ( xj_data.url != '')
          {
            repeat_cont += '<a href="' + xj_data.url + '" target="_blank" class="link_pdf fade">';
          }
      
      if ( xj_data.url != '' && xj_data.size != '－' )
          {
            repeat_cont += ' <span class="icon">【PDF】</span>' ;
          }
      repeat_cont += '<span class="txt">' + xj_data.title ;
      
      
      if ( xj_data.url != '' && xj_data.size != '－' )
          {
            repeat_cont += ' (' + xj_data.size + 'B/' + xj_data.page + 'P）' ;
          }
          
      
      if ( xj_data.url != '' )
          {
            repeat_cont += '</span></a>' ;
          }
          
      
          
      repeat_cont += '</span></li>' ;

      
    }

    if ( repeat_cont !== '' )
    {
      cont += repeat_cont;
    }
    else
    {
      cont += '<li>ただいま掲載すべき事項はございません。</li>' ;
    }
    $this.find( '[data-id="' + display_id + '"]').html( cont );
  }


  var xj_storage_loader = new XjStorageLoaderLibraryKessan();
});

}(jQuery));